import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertTo',
})
export class ConvertToPipe implements PipeTransform {
  transform(
    value: any,
    fromUnit: AvailableUnit | string,
    toUnit: AvailableUnit | string,
    showOnlyUnit: boolean = false,
    showUnit: boolean = true,
    uppercase: boolean = true
  ): any {
    if (showOnlyUnit) {
      return `${uppercase ? toUnit.toUpperCase() : toUnit}`;
    }

    if (fromUnit === toUnit) {
      return `${value} ${uppercase ? fromUnit.toUpperCase() : fromUnit}`;
    }

    if (
      (fromUnit.localeCompare('g') && toUnit.localeCompare('kg')) ||
      (fromUnit.localeCompare('ml') && toUnit.localeCompare('l')) ||
      (fromUnit.localeCompare('mm') && toUnit.localeCompare('m'))
    ) {
      return `${(value / 1000).toFixed(3)} ${
        showUnit ? (uppercase ? toUnit.toUpperCase() : toUnit) : ''
      }`;
    }

    if (
      (fromUnit.localeCompare('kg') && toUnit.localeCompare('g')) ||
      (fromUnit.localeCompare('l') && toUnit.localeCompare('ml'))
    ) {
      return `${value * 1000} ${
        showUnit ? (uppercase ? toUnit.toUpperCase() : toUnit) : ''
      }`;
    }

    return `${value} ${uppercase ? fromUnit.toUpperCase() : fromUnit}`;
  }
}

type AvailableUnit = 'g' | 'kg' | 'ml' | 'l';
